<!-- src/app/components/theme-toggle/theme-toggle.component.html -->
<ion-button fill="clear" (click)="toggleTheme()">
  <ion-icon 
    slot="icon-only" 
    [name]="currentTheme == 'dark' ? 'sunny' : 'moon'">
  </ion-icon>
</ion-button>